"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _autoBind = _interopRequireDefault(require("auto-bind"));

var _marshaler = _interopRequireDefault(require("../util/marshaler"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var remaps = [['nats', 'provider.nats'], ['mqtt', 'provider.mqtt']];

var PubSub = /*#__PURE__*/function () {
  function PubSub(registry) {
    (0, _classCallCheck2["default"])(this, PubSub);
    this._api = registry;
    (0, _autoBind["default"])(this);
  }

  (0, _createClass2["default"])(PubSub, [{
    key: "_fillZeroValues",
    value: function _fillZeroValues(pubsub, paths) {
      // Add zero values that would otherwise be swallowed by the http bridge.
      if ((paths.includes('provider.mqtt') || paths.includes('provider.mqtt.publish_qos')) && 'mqtt' in pubsub && !('publish_qos' in pubsub.mqtt)) {
        pubsub.mqtt.publish_qos = 'AT_MOST_ONCE';
      }

      if ((paths.includes('provider.mqtt') || paths.includes('provider.mqtt.subscribe_qos')) && 'mqtt' in pubsub && !('subscribe_qos' in pubsub.mqtt)) {
        pubsub.mqtt.subscribe_qos = 'AT_MOST_ONCE';
      }

      if ((paths.includes('provider.mqtt') || paths.includes('provider.mqtt.use_tls')) && 'mqtt' in pubsub && !('use_tls' in pubsub.mqtt)) {
        pubsub.mqtt.use_tls = false;
      }
    }
  }, {
    key: "getAll",
    value: function () {
      var _getAll = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(appId, selector) {
        var result;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._api.List({
                  routeParams: {
                    'application_ids.application_id': appId
                  }
                }, _objectSpread({}, _marshaler["default"].selectorToFieldMask(selector)));

              case 2:
                result = _context.sent;
                return _context.abrupt("return", _marshaler["default"].payloadListResponse('pubsubs', result));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAll(_x, _x2) {
        return _getAll.apply(this, arguments);
      }

      return getAll;
    }()
  }, {
    key: "create",
    value: function () {
      var _create = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(appId, pubsub) {
        var mask,
            result,
            _args2 = arguments;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                mask = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : _marshaler["default"].fieldMaskFromPatch(pubsub, this._api.SetAllowedFieldMaskPaths, remaps);
                _context2.next = 3;
                return this._api.Set({
                  routeParams: {
                    'pubsub.ids.application_ids.application_id': appId
                  }
                }, {
                  pubsub: pubsub,
                  field_mask: _marshaler["default"].fieldMask(mask)
                });

              case 3:
                result = _context2.sent;
                return _context2.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function create(_x3, _x4) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "getById",
    value: function () {
      var _getById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(appId, pubsubId, selector) {
        var fieldMask, paths, result, pubsub;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                fieldMask = _marshaler["default"].selectorToFieldMask(selector);
                paths = fieldMask.field_mask.paths;
                _context3.next = 4;
                return this._api.Get({
                  routeParams: {
                    'ids.application_ids.application_id': appId,
                    'ids.pub_sub_id': pubsubId
                  }
                }, fieldMask);

              case 4:
                result = _context3.sent;
                pubsub = _marshaler["default"].payloadSingleResponse(result);

                this._fillZeroValues(pubsub, paths);

                return _context3.abrupt("return", pubsub);

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getById(_x5, _x6, _x7) {
        return _getById.apply(this, arguments);
      }

      return getById;
    }()
  }, {
    key: "updateById",
    value: function () {
      var _updateById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(appId, pubsubId, patch) {
        var mask,
            result,
            _args4 = arguments;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                mask = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : _marshaler["default"].fieldMaskFromPatch(patch, this._api.SetAllowedFieldMaskPaths, remaps);
                _context4.next = 3;
                return this._api.Set({
                  routeParams: {
                    'pubsub.ids.application_ids.application_id': appId,
                    'pubsub.ids.pub_sub_id': pubsubId
                  }
                }, {
                  pubsub: patch,
                  field_mask: _marshaler["default"].fieldMask(mask)
                });

              case 3:
                result = _context4.sent;
                return _context4.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function updateById(_x8, _x9, _x10) {
        return _updateById.apply(this, arguments);
      }

      return updateById;
    }()
  }, {
    key: "deleteById",
    value: function () {
      var _deleteById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(appId, pubsubId) {
        var result;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._api.Delete({
                  routeParams: {
                    'application_ids.application_id': appId,
                    pub_sub_id: pubsubId
                  }
                });

              case 2:
                result = _context5.sent;
                return _context5.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function deleteById(_x11, _x12) {
        return _deleteById.apply(this, arguments);
      }

      return deleteById;
    }()
  }, {
    key: "getFormats",
    value: function () {
      var _getFormats = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
        var result;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._api.GetFormats();

              case 2:
                result = _context6.sent;
                return _context6.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getFormats() {
        return _getFormats.apply(this, arguments);
      }

      return getFormats;
    }()
  }]);
  return PubSub;
}();

var _default = PubSub;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJyZW1hcHMiLCJQdWJTdWIiLCJyZWdpc3RyeSIsIl9hcGkiLCJhdXRvQmluZCIsInB1YnN1YiIsInBhdGhzIiwiaW5jbHVkZXMiLCJtcXR0IiwicHVibGlzaF9xb3MiLCJzdWJzY3JpYmVfcW9zIiwidXNlX3RscyIsImFwcElkIiwic2VsZWN0b3IiLCJMaXN0Iiwicm91dGVQYXJhbXMiLCJNYXJzaGFsZXIiLCJzZWxlY3RvclRvRmllbGRNYXNrIiwicmVzdWx0IiwicGF5bG9hZExpc3RSZXNwb25zZSIsIm1hc2siLCJmaWVsZE1hc2tGcm9tUGF0Y2giLCJTZXRBbGxvd2VkRmllbGRNYXNrUGF0aHMiLCJTZXQiLCJmaWVsZF9tYXNrIiwiZmllbGRNYXNrIiwicGF5bG9hZFNpbmdsZVJlc3BvbnNlIiwicHVic3ViSWQiLCJHZXQiLCJfZmlsbFplcm9WYWx1ZXMiLCJwYXRjaCIsIkRlbGV0ZSIsInB1Yl9zdWJfaWQiLCJHZXRGb3JtYXRzIl0sInNvdXJjZXMiOlsiLi4vLi4vc3JjL3NlcnZpY2UvcHVic3Vicy5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyIvLyBDb3B5cmlnaHQgwqkgMjAxOSBUaGUgVGhpbmdzIE5ldHdvcmsgRm91bmRhdGlvbiwgVGhlIFRoaW5ncyBJbmR1c3RyaWVzIEIuVi5cbi8vXG4vLyBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuLy8geW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuLy8gWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4vL1xuLy8gICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuLy9cbi8vIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbi8vIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbi8vIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuLy8gU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuLy8gbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG5cbmltcG9ydCBhdXRvQmluZCBmcm9tICdhdXRvLWJpbmQnXG5cbmltcG9ydCBNYXJzaGFsZXIgZnJvbSAnLi4vdXRpbC9tYXJzaGFsZXInXG5cbmNvbnN0IHJlbWFwcyA9IFtcbiAgWyduYXRzJywgJ3Byb3ZpZGVyLm5hdHMnXSxcbiAgWydtcXR0JywgJ3Byb3ZpZGVyLm1xdHQnXSxcbl1cblxuY2xhc3MgUHViU3ViIHtcbiAgY29uc3RydWN0b3IocmVnaXN0cnkpIHtcbiAgICB0aGlzLl9hcGkgPSByZWdpc3RyeVxuICAgIGF1dG9CaW5kKHRoaXMpXG4gIH1cblxuICBfZmlsbFplcm9WYWx1ZXMocHVic3ViLCBwYXRocykge1xuICAgIC8vIEFkZCB6ZXJvIHZhbHVlcyB0aGF0IHdvdWxkIG90aGVyd2lzZSBiZSBzd2FsbG93ZWQgYnkgdGhlIGh0dHAgYnJpZGdlLlxuICAgIGlmIChcbiAgICAgIChwYXRocy5pbmNsdWRlcygncHJvdmlkZXIubXF0dCcpIHx8IHBhdGhzLmluY2x1ZGVzKCdwcm92aWRlci5tcXR0LnB1Ymxpc2hfcW9zJykpICYmXG4gICAgICAnbXF0dCcgaW4gcHVic3ViICYmXG4gICAgICAhKCdwdWJsaXNoX3FvcycgaW4gcHVic3ViLm1xdHQpXG4gICAgKSB7XG4gICAgICBwdWJzdWIubXF0dC5wdWJsaXNoX3FvcyA9ICdBVF9NT1NUX09OQ0UnXG4gICAgfVxuXG4gICAgaWYgKFxuICAgICAgKHBhdGhzLmluY2x1ZGVzKCdwcm92aWRlci5tcXR0JykgfHwgcGF0aHMuaW5jbHVkZXMoJ3Byb3ZpZGVyLm1xdHQuc3Vic2NyaWJlX3FvcycpKSAmJlxuICAgICAgJ21xdHQnIGluIHB1YnN1YiAmJlxuICAgICAgISgnc3Vic2NyaWJlX3FvcycgaW4gcHVic3ViLm1xdHQpXG4gICAgKSB7XG4gICAgICBwdWJzdWIubXF0dC5zdWJzY3JpYmVfcW9zID0gJ0FUX01PU1RfT05DRSdcbiAgICB9XG5cbiAgICBpZiAoXG4gICAgICAocGF0aHMuaW5jbHVkZXMoJ3Byb3ZpZGVyLm1xdHQnKSB8fCBwYXRocy5pbmNsdWRlcygncHJvdmlkZXIubXF0dC51c2VfdGxzJykpICYmXG4gICAgICAnbXF0dCcgaW4gcHVic3ViICYmXG4gICAgICAhKCd1c2VfdGxzJyBpbiBwdWJzdWIubXF0dClcbiAgICApIHtcbiAgICAgIHB1YnN1Yi5tcXR0LnVzZV90bHMgPSBmYWxzZVxuICAgIH1cbiAgfVxuXG4gIGFzeW5jIGdldEFsbChhcHBJZCwgc2VsZWN0b3IpIHtcbiAgICBjb25zdCByZXN1bHQgPSBhd2FpdCB0aGlzLl9hcGkuTGlzdChcbiAgICAgIHtcbiAgICAgICAgcm91dGVQYXJhbXM6IHsgJ2FwcGxpY2F0aW9uX2lkcy5hcHBsaWNhdGlvbl9pZCc6IGFwcElkIH0sXG4gICAgICB9LFxuICAgICAge1xuICAgICAgICAuLi5NYXJzaGFsZXIuc2VsZWN0b3JUb0ZpZWxkTWFzayhzZWxlY3RvciksXG4gICAgICB9LFxuICAgIClcblxuICAgIHJldHVybiBNYXJzaGFsZXIucGF5bG9hZExpc3RSZXNwb25zZSgncHVic3VicycsIHJlc3VsdClcbiAgfVxuXG4gIGFzeW5jIGNyZWF0ZShcbiAgICBhcHBJZCxcbiAgICBwdWJzdWIsXG4gICAgbWFzayA9IE1hcnNoYWxlci5maWVsZE1hc2tGcm9tUGF0Y2gocHVic3ViLCB0aGlzLl9hcGkuU2V0QWxsb3dlZEZpZWxkTWFza1BhdGhzLCByZW1hcHMpLFxuICApIHtcbiAgICBjb25zdCByZXN1bHQgPSBhd2FpdCB0aGlzLl9hcGkuU2V0KFxuICAgICAge1xuICAgICAgICByb3V0ZVBhcmFtczoge1xuICAgICAgICAgICdwdWJzdWIuaWRzLmFwcGxpY2F0aW9uX2lkcy5hcHBsaWNhdGlvbl9pZCc6IGFwcElkLFxuICAgICAgICB9LFxuICAgICAgfSxcbiAgICAgIHtcbiAgICAgICAgcHVic3ViLFxuICAgICAgICBmaWVsZF9tYXNrOiBNYXJzaGFsZXIuZmllbGRNYXNrKG1hc2spLFxuICAgICAgfSxcbiAgICApXG5cbiAgICByZXR1cm4gTWFyc2hhbGVyLnBheWxvYWRTaW5nbGVSZXNwb25zZShyZXN1bHQpXG4gIH1cblxuICBhc3luYyBnZXRCeUlkKGFwcElkLCBwdWJzdWJJZCwgc2VsZWN0b3IpIHtcbiAgICBjb25zdCBmaWVsZE1hc2sgPSBNYXJzaGFsZXIuc2VsZWN0b3JUb0ZpZWxkTWFzayhzZWxlY3RvcilcbiAgICBjb25zdCBwYXRocyA9IGZpZWxkTWFzay5maWVsZF9tYXNrLnBhdGhzXG4gICAgY29uc3QgcmVzdWx0ID0gYXdhaXQgdGhpcy5fYXBpLkdldChcbiAgICAgIHtcbiAgICAgICAgcm91dGVQYXJhbXM6IHtcbiAgICAgICAgICAnaWRzLmFwcGxpY2F0aW9uX2lkcy5hcHBsaWNhdGlvbl9pZCc6IGFwcElkLFxuICAgICAgICAgICdpZHMucHViX3N1Yl9pZCc6IHB1YnN1YklkLFxuICAgICAgICB9LFxuICAgICAgfSxcbiAgICAgIGZpZWxkTWFzayxcbiAgICApXG5cbiAgICBjb25zdCBwdWJzdWIgPSBNYXJzaGFsZXIucGF5bG9hZFNpbmdsZVJlc3BvbnNlKHJlc3VsdClcbiAgICB0aGlzLl9maWxsWmVyb1ZhbHVlcyhwdWJzdWIsIHBhdGhzKVxuXG4gICAgcmV0dXJuIHB1YnN1YlxuICB9XG5cbiAgYXN5bmMgdXBkYXRlQnlJZChcbiAgICBhcHBJZCxcbiAgICBwdWJzdWJJZCxcbiAgICBwYXRjaCxcbiAgICBtYXNrID0gTWFyc2hhbGVyLmZpZWxkTWFza0Zyb21QYXRjaChwYXRjaCwgdGhpcy5fYXBpLlNldEFsbG93ZWRGaWVsZE1hc2tQYXRocywgcmVtYXBzKSxcbiAgKSB7XG4gICAgY29uc3QgcmVzdWx0ID0gYXdhaXQgdGhpcy5fYXBpLlNldChcbiAgICAgIHtcbiAgICAgICAgcm91dGVQYXJhbXM6IHtcbiAgICAgICAgICAncHVic3ViLmlkcy5hcHBsaWNhdGlvbl9pZHMuYXBwbGljYXRpb25faWQnOiBhcHBJZCxcbiAgICAgICAgICAncHVic3ViLmlkcy5wdWJfc3ViX2lkJzogcHVic3ViSWQsXG4gICAgICAgIH0sXG4gICAgICB9LFxuICAgICAge1xuICAgICAgICBwdWJzdWI6IHBhdGNoLFxuICAgICAgICBmaWVsZF9tYXNrOiBNYXJzaGFsZXIuZmllbGRNYXNrKG1hc2spLFxuICAgICAgfSxcbiAgICApXG5cbiAgICByZXR1cm4gTWFyc2hhbGVyLnBheWxvYWRTaW5nbGVSZXNwb25zZShyZXN1bHQpXG4gIH1cblxuICBhc3luYyBkZWxldGVCeUlkKGFwcElkLCBwdWJzdWJJZCkge1xuICAgIGNvbnN0IHJlc3VsdCA9IGF3YWl0IHRoaXMuX2FwaS5EZWxldGUoe1xuICAgICAgcm91dGVQYXJhbXM6IHtcbiAgICAgICAgJ2FwcGxpY2F0aW9uX2lkcy5hcHBsaWNhdGlvbl9pZCc6IGFwcElkLFxuICAgICAgICBwdWJfc3ViX2lkOiBwdWJzdWJJZCxcbiAgICAgIH0sXG4gICAgfSlcblxuICAgIHJldHVybiBNYXJzaGFsZXIucGF5bG9hZFNpbmdsZVJlc3BvbnNlKHJlc3VsdClcbiAgfVxuXG4gIGFzeW5jIGdldEZvcm1hdHMoKSB7XG4gICAgY29uc3QgcmVzdWx0ID0gYXdhaXQgdGhpcy5fYXBpLkdldEZvcm1hdHMoKVxuXG4gICAgcmV0dXJuIE1hcnNoYWxlci5wYXlsb2FkU2luZ2xlUmVzcG9uc2UocmVzdWx0KVxuICB9XG59XG5cbmV4cG9ydCBkZWZhdWx0IFB1YlN1YlxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBY0E7O0FBRUE7Ozs7OztBQUVBLElBQU1BLE1BQU0sR0FBRyxDQUNiLENBQUMsTUFBRCxFQUFTLGVBQVQsQ0FEYSxFQUViLENBQUMsTUFBRCxFQUFTLGVBQVQsQ0FGYSxDQUFmOztJQUtNQyxNO0VBQ0osZ0JBQVlDLFFBQVosRUFBc0I7SUFBQTtJQUNwQixLQUFLQyxJQUFMLEdBQVlELFFBQVo7SUFDQSxJQUFBRSxvQkFBQSxFQUFTLElBQVQ7RUFDRDs7OztXQUVELHlCQUFnQkMsTUFBaEIsRUFBd0JDLEtBQXhCLEVBQStCO01BQzdCO01BQ0EsSUFDRSxDQUFDQSxLQUFLLENBQUNDLFFBQU4sQ0FBZSxlQUFmLEtBQW1DRCxLQUFLLENBQUNDLFFBQU4sQ0FBZSwyQkFBZixDQUFwQyxLQUNBLFVBQVVGLE1BRFYsSUFFQSxFQUFFLGlCQUFpQkEsTUFBTSxDQUFDRyxJQUExQixDQUhGLEVBSUU7UUFDQUgsTUFBTSxDQUFDRyxJQUFQLENBQVlDLFdBQVosR0FBMEIsY0FBMUI7TUFDRDs7TUFFRCxJQUNFLENBQUNILEtBQUssQ0FBQ0MsUUFBTixDQUFlLGVBQWYsS0FBbUNELEtBQUssQ0FBQ0MsUUFBTixDQUFlLDZCQUFmLENBQXBDLEtBQ0EsVUFBVUYsTUFEVixJQUVBLEVBQUUsbUJBQW1CQSxNQUFNLENBQUNHLElBQTVCLENBSEYsRUFJRTtRQUNBSCxNQUFNLENBQUNHLElBQVAsQ0FBWUUsYUFBWixHQUE0QixjQUE1QjtNQUNEOztNQUVELElBQ0UsQ0FBQ0osS0FBSyxDQUFDQyxRQUFOLENBQWUsZUFBZixLQUFtQ0QsS0FBSyxDQUFDQyxRQUFOLENBQWUsdUJBQWYsQ0FBcEMsS0FDQSxVQUFVRixNQURWLElBRUEsRUFBRSxhQUFhQSxNQUFNLENBQUNHLElBQXRCLENBSEYsRUFJRTtRQUNBSCxNQUFNLENBQUNHLElBQVAsQ0FBWUcsT0FBWixHQUFzQixLQUF0QjtNQUNEO0lBQ0Y7Ozs7a0dBRUQsaUJBQWFDLEtBQWIsRUFBb0JDLFFBQXBCO1FBQUE7UUFBQTtVQUFBO1lBQUE7Y0FBQTtnQkFBQTtnQkFBQSxPQUN1QixLQUFLVixJQUFMLENBQVVXLElBQVYsQ0FDbkI7a0JBQ0VDLFdBQVcsRUFBRTtvQkFBRSxrQ0FBa0NIO2tCQUFwQztnQkFEZixDQURtQixvQkFLZEkscUJBQUEsQ0FBVUMsbUJBQVYsQ0FBOEJKLFFBQTlCLENBTGMsRUFEdkI7O2NBQUE7Z0JBQ1FLLE1BRFI7Z0JBQUEsaUNBVVNGLHFCQUFBLENBQVVHLG1CQUFWLENBQThCLFNBQTlCLEVBQXlDRCxNQUF6QyxDQVZUOztjQUFBO2NBQUE7Z0JBQUE7WUFBQTtVQUFBO1FBQUE7TUFBQSxDOzs7Ozs7Ozs7OztrR0FhQSxrQkFDRU4sS0FERixFQUVFUCxNQUZGO1FBQUE7UUFBQTtRQUFBO1FBQUE7VUFBQTtZQUFBO2NBQUE7Z0JBR0VlLElBSEYsOERBR1NKLHFCQUFBLENBQVVLLGtCQUFWLENBQTZCaEIsTUFBN0IsRUFBcUMsS0FBS0YsSUFBTCxDQUFVbUIsd0JBQS9DLEVBQXlFdEIsTUFBekUsQ0FIVDtnQkFBQTtnQkFBQSxPQUt1QixLQUFLRyxJQUFMLENBQVVvQixHQUFWLENBQ25CO2tCQUNFUixXQUFXLEVBQUU7b0JBQ1gsNkNBQTZDSDtrQkFEbEM7Z0JBRGYsQ0FEbUIsRUFNbkI7a0JBQ0VQLE1BQU0sRUFBTkEsTUFERjtrQkFFRW1CLFVBQVUsRUFBRVIscUJBQUEsQ0FBVVMsU0FBVixDQUFvQkwsSUFBcEI7Z0JBRmQsQ0FObUIsQ0FMdkI7O2NBQUE7Z0JBS1FGLE1BTFI7Z0JBQUEsa0NBaUJTRixxQkFBQSxDQUFVVSxxQkFBVixDQUFnQ1IsTUFBaEMsQ0FqQlQ7O2NBQUE7Y0FBQTtnQkFBQTtZQUFBO1VBQUE7UUFBQTtNQUFBLEM7Ozs7Ozs7Ozs7O21HQW9CQSxrQkFBY04sS0FBZCxFQUFxQmUsUUFBckIsRUFBK0JkLFFBQS9CO1FBQUE7UUFBQTtVQUFBO1lBQUE7Y0FBQTtnQkFDUVksU0FEUixHQUNvQlQscUJBQUEsQ0FBVUMsbUJBQVYsQ0FBOEJKLFFBQTlCLENBRHBCO2dCQUVRUCxLQUZSLEdBRWdCbUIsU0FBUyxDQUFDRCxVQUFWLENBQXFCbEIsS0FGckM7Z0JBQUE7Z0JBQUEsT0FHdUIsS0FBS0gsSUFBTCxDQUFVeUIsR0FBVixDQUNuQjtrQkFDRWIsV0FBVyxFQUFFO29CQUNYLHNDQUFzQ0gsS0FEM0I7b0JBRVgsa0JBQWtCZTtrQkFGUDtnQkFEZixDQURtQixFQU9uQkYsU0FQbUIsQ0FIdkI7O2NBQUE7Z0JBR1FQLE1BSFI7Z0JBYVFiLE1BYlIsR0FhaUJXLHFCQUFBLENBQVVVLHFCQUFWLENBQWdDUixNQUFoQyxDQWJqQjs7Z0JBY0UsS0FBS1csZUFBTCxDQUFxQnhCLE1BQXJCLEVBQTZCQyxLQUE3Qjs7Z0JBZEYsa0NBZ0JTRCxNQWhCVDs7Y0FBQTtjQUFBO2dCQUFBO1lBQUE7VUFBQTtRQUFBO01BQUEsQzs7Ozs7Ozs7Ozs7c0dBbUJBLGtCQUNFTyxLQURGLEVBRUVlLFFBRkYsRUFHRUcsS0FIRjtRQUFBO1FBQUE7UUFBQTtRQUFBO1VBQUE7WUFBQTtjQUFBO2dCQUlFVixJQUpGLDhEQUlTSixxQkFBQSxDQUFVSyxrQkFBVixDQUE2QlMsS0FBN0IsRUFBb0MsS0FBSzNCLElBQUwsQ0FBVW1CLHdCQUE5QyxFQUF3RXRCLE1BQXhFLENBSlQ7Z0JBQUE7Z0JBQUEsT0FNdUIsS0FBS0csSUFBTCxDQUFVb0IsR0FBVixDQUNuQjtrQkFDRVIsV0FBVyxFQUFFO29CQUNYLDZDQUE2Q0gsS0FEbEM7b0JBRVgseUJBQXlCZTtrQkFGZDtnQkFEZixDQURtQixFQU9uQjtrQkFDRXRCLE1BQU0sRUFBRXlCLEtBRFY7a0JBRUVOLFVBQVUsRUFBRVIscUJBQUEsQ0FBVVMsU0FBVixDQUFvQkwsSUFBcEI7Z0JBRmQsQ0FQbUIsQ0FOdkI7O2NBQUE7Z0JBTVFGLE1BTlI7Z0JBQUEsa0NBbUJTRixxQkFBQSxDQUFVVSxxQkFBVixDQUFnQ1IsTUFBaEMsQ0FuQlQ7O2NBQUE7Y0FBQTtnQkFBQTtZQUFBO1VBQUE7UUFBQTtNQUFBLEM7Ozs7Ozs7Ozs7O3NHQXNCQSxrQkFBaUJOLEtBQWpCLEVBQXdCZSxRQUF4QjtRQUFBO1FBQUE7VUFBQTtZQUFBO2NBQUE7Z0JBQUE7Z0JBQUEsT0FDdUIsS0FBS3hCLElBQUwsQ0FBVTRCLE1BQVYsQ0FBaUI7a0JBQ3BDaEIsV0FBVyxFQUFFO29CQUNYLGtDQUFrQ0gsS0FEdkI7b0JBRVhvQixVQUFVLEVBQUVMO2tCQUZEO2dCQUR1QixDQUFqQixDQUR2Qjs7Y0FBQTtnQkFDUVQsTUFEUjtnQkFBQSxrQ0FRU0YscUJBQUEsQ0FBVVUscUJBQVYsQ0FBZ0NSLE1BQWhDLENBUlQ7O2NBQUE7Y0FBQTtnQkFBQTtZQUFBO1VBQUE7UUFBQTtNQUFBLEM7Ozs7Ozs7Ozs7O3NHQVdBO1FBQUE7UUFBQTtVQUFBO1lBQUE7Y0FBQTtnQkFBQTtnQkFBQSxPQUN1QixLQUFLZixJQUFMLENBQVU4QixVQUFWLEVBRHZCOztjQUFBO2dCQUNRZixNQURSO2dCQUFBLGtDQUdTRixxQkFBQSxDQUFVVSxxQkFBVixDQUFnQ1IsTUFBaEMsQ0FIVDs7Y0FBQTtjQUFBO2dCQUFBO1lBQUE7VUFBQTtRQUFBO01BQUEsQzs7Ozs7Ozs7Ozs7O2VBT2FqQixNIn0=